import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import Radio from '@material-ui/core/Radio/Radio';
import { ZAJAVL_CONSENT_FILE_TYPE, ZAJAVL_REFUSAL_FILE_TYPE } from '../../../constants';
import {useTranslation} from "react-i18next";

const FileTypeRadio = ({handleChange, value}) => {
    const { t } = useTranslation();

    return (
        <FormControl component="fieldset" size="small">
            <FormLabel component="legend">{t('select_file_type_and_upload')}</FormLabel>
            <RadioGroup
                value={value}
                onChange={handleChange}>
                <FormControlLabel
                    value={ZAJAVL_CONSENT_FILE_TYPE}
                    control={<Radio color="primary"/>}
                    label={t('enrollment_consent')}/>
                <FormControlLabel
                    value={ZAJAVL_REFUSAL_FILE_TYPE}
                    control={<Radio color="primary"/>}
                    label={t('enrollment_refusal')}/>
            </RadioGroup>
        </FormControl>
    );
};
export default FileTypeRadio;